import * as React from 'react';
import { calculateTotalCLPurchasePrice, isSubscriptionPurchase, PricedAddToCartCTA } from '@grandvisionhq/fun-products';
import { useProductDetailContext } from '../../../../../../Context/ProductDetailContext.js';
import { useCLEcommContext } from '../../../../context/CLEcommContext.js';

/** @deprecated */ const CLAddToCartCTA = ({ className , lineItemDrafts  })=>{
    const { activeVariant  } = useProductDetailContext();
    const { state  } = useCLEcommContext();
    const { left , right  } = state.queries;
    const { purchaseType  } = state.configurations;
    const { deliveryInterval  } = state.configurations.subscriptionPurchaseConfigurations;
    const unitPrice = activeVariant.purchaseTypePrices[purchaseType];
    const totalPrice = calculateTotalCLPurchasePrice(state, unitPrice);
    const priceInterval = isSubscriptionPurchase(purchaseType) && !!deliveryInterval ? deliveryInterval : undefined;
    return /*#__PURE__*/ React.createElement(PricedAddToCartCTA, {
        className: className,
        lineItemDrafts: lineItemDrafts,
        price: totalPrice,
        priceInterval: priceInterval,
        isLoading: left.loading || right.loading
    });
};

export { CLAddToCartCTA };
//# sourceMappingURL=CLAddToCartCTA.js.map
